module.exports = __webpack_public_path__ + "static/img/pic_kol.12bd5cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/pic_kol.png
// module id = Jv4l
// module chunks = 0